var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPipelineLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 850.3 973.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.65,
    y1: 241.84,
    x2: 849.64,
    y2: 732.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191a1c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.11,
    y1: 242.77,
    x2: 424.72,
    y2: 487.91,
    xlinkHref: "#linear-gradient"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "0 730.89 0 242.96 425.2 0 850.3 242.97 850.3 730.87 425.2 973.86 0 730.89",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 730.89 425.22 487.06 425.2 0 0 242.96 0 730.89",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 730.89 425.22 487.06 850.3 730.87 425.2 973.86 0 730.89",
    style: {
      opacity: 0.32
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "0 242.96 165.32 329.09 165.39 639.01 425.02 793.89 425.2 973.86 0 730.89 0 242.96",
    style: {
      opacity: 0.16
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "644.19 460.77 644.12 460.77 600.38 486.87 600.38 486.93 644.12 513.04 644.19 513.1 687.99 539.27 687.99 486.93 687.99 434.6 644.19 460.77",
    style: {
      fill: "#191a1c",
      opacity: 0.64
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.64
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M644.19,356.1l-.12,.06-43.68,26.11h-.06l.06,52.27v52.33l43.74-26.11v-.06l.06,.06,43.8-26.17v-104.67l-43.8,26.17Zm-.06,52.4v-.12l.06,.06-.06,.06Z",
    style: {
      fill: "#c40818"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "556.58 460.86 556.58 460.8 512.78 434.63 512.84 486.9 512.84 487.02 512.91 539.24 556.58 513.19 556.65 513.13 600.38 487.02 600.38 486.96 556.58 460.86",
    style: {
      fill: "#303132"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.12,565.53l-43.68,26.11v.12l-.12-.06-43.68,26.11v.12l-.12-.06-43.56,25.98v.19l-.18-.06-43.74,26.11v.12l-.12-.06-43.8,26.17v104.73l43.99-26.23v-.06l43.92-26.23,43.62-25.98,43.86-26.23,43.68-26.04,43.8-26.17v-104.73l-43.86,26.17Zm-131.34,130.84l.18-.12v.19l-.18-.06Zm87.6-52.27l.12-.06v.12l-.12-.06Z",
    style: {
      fill: "#b6b8bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.19,513.19h-.06v-.06l-43.74-26.11-43.74,26.11v.06h-.06l-43.68,26.04v.19l-.18-.12-43.74,26.17v.06l-.06-.06-43.8,26.17v104.67l43.8-26.17,.12-.06,43.74-26.11,.18-.12,43.56-25.98,.12-.06,43.68-26.11,.12-.06,43.68-26.11,43.86-26.17-43.8-26.17Zm-175.2,104.61l.06-.06v.12l-.06-.06Zm43.74-26.11l.18-.12v.19l-.18-.06Zm43.8-26.17l.12-.06v.12l-.12-.06Zm43.8-26.17l.12-.06v.06h-.12Z",
    style: {
      fill: "#303132"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.84,487.02l-.06-.06,.06-.06-.06-52.27-43.8,26.17h-.06l-43.8,26.17v104.67l43.8-26.17h.06l43.74-26.17,.18-.06-.06-52.21Zm-43.92,26.11h.06v.06l-.06-.06Z",
    style: {
      fill: "#c40818"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.64
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M644.06,303.73l-43.8-26.17-43.68-26.11-.06-.06-43.86-26.17-43.74,26.11-.12,.06-43.68,26.11v.06l43.74,26.17h.06l43.74,26.17h.06v.06l43.74,26.11,.12-.06v.12l43.74,26.17,.06,.06,43.68-26.11v-.12l.12,.06,43.8-26.17-43.92-26.29Zm-87.6,0l.12-.06v.12l-.12-.06Z",
    style: {
      fill: "#eb0a1e"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M600.32,382.36v-.06l-43.74-26.17-.12-.06-43.74-26.11v-.06h-.06l-43.74-26.17h-.06l-43.74-26.17v104.67l43.8,26.17,43.86,26.23,43.8,26.17v.06l43.8,26.11v-52.33l-.06-52.27Zm-87.66-.12l.12-.06v.12l-.12-.06Z",
    style: {
      fill: "#191a1c",
      opacity: 0.64
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "468.92 408.4 425.12 382.23 381.32 408.4 337.52 434.63 381.26 460.8 381.32 460.8 425.12 486.96 468.92 460.8 468.98 460.8 512.78 434.63 468.92 408.4",
    style: {
      fill: "#eb0a1e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "468.8 198.94 425.12 172.83 381.32 199.06 337.52 225.23 381.32 251.4 425.06 277.57 425.12 277.57 425.12 277.5 468.8 251.4 468.8 251.27 468.92 251.34 512.66 225.23 468.8 198.94",
    style: {
      fill: "#191a1c",
      opacity: 0.64
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.32 460.8 381.26 460.8 337.52 434.63 337.52 486.96 337.52 539.3 337.52 539.36 381.32 565.46 425.12 591.63 425.12 539.3 425.12 486.96 381.32 460.8",
    style: {
      fill: "#fa4d56"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.46 434.63 293.72 460.8 293.65 460.8 293.65 460.86 249.92 486.96 249.92 487.02 293.65 513.13 293.72 513.19 337.52 539.3 337.52 486.96 337.52 434.63 337.46 434.63",
    style: {
      fill: "#303132"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.06 277.57 424.93 277.63 381.32 303.73 381.32 303.79 337.58 329.9 337.52 329.9 337.52 329.96 293.78 356.07 293.65 356.19 249.92 382.3 249.92 382.36 249.92 434.63 249.92 434.69 249.92 486.96 293.65 460.86 293.65 460.8 293.72 460.8 337.46 434.63 337.52 434.63 381.32 408.4 425.12 382.23 425.12 329.9 425.12 277.57 425.06 277.57",
    style: {
      fill: "#191a1c",
      opacity: 0.64
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.32,565.46l-43.8-26.11v-.06l-43.8-26.11h-.06v-.06l-43.74-26.11-43.8,26.17-43.8,26.17,43.8,26.17h.06l43.74,26.17h.06l43.68,26.11,.06,.06,43.8,26.11,43.8,26.17,43.8,26.17v-104.67l-43.8-26.17Zm-87.66,.12v-.12l.06,.06-.06,.06Z",
    style: {
      fill: "#303132"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.64
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.32,251.4l-43.8-26.17-43.86,26.23-43.68,26.11-.06,.06-43.68,26.11-.12,.12-43.8,26.17,43.8,26.17,43.8,26.11,43.74-26.11v-.19l.12,.06,43.74-26.11v-.06h.06l43.74-26.11v-.06l43.62-26.11,.12-.06-43.74-26.17Zm-131.4,78.56v-.12l.12,.06-.12,.06Zm43.74-26.17v-.12l.06,.06-.06,.06Zm43.8-26.17l.06-.06v.06h-.06Z",
    style: {
      fill: "#eb0a1e"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "206.11 356.19 162.31 330.02 162.31 382.36 162.31 434.69 206.11 460.86 249.92 486.96 249.92 434.69 249.92 434.63 249.92 382.36 249.92 382.3 206.11 356.19",
    style: {
      fill: "#fa4d56",
      opacity: 0.64
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.11 460.86 162.31 434.69 162.31 487.02 162.31 539.36 206.11 513.19 249.92 487.02 249.92 486.96 206.11 460.86",
    style: {
      fill: "#191a1c",
      opacity: 0.64
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.32 670.13 337.52 643.97 293.72 617.86 293.65 617.86 293.65 617.8 249.98 591.69 249.92 591.69 206.18 565.53 206.11 565.53 162.31 539.36 162.31 591.75 162.31 644.09 206.11 670.26 249.85 696.36 293.65 722.53 337.52 748.7 381.32 774.86 425.12 801.03 425.12 748.7 425.12 696.3 381.32 670.13",
    style: {
      fill: "#dbdcde"
    }
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipelineLogo);
export default __webpack_public_path__ + "static/media/PipelineLogo.afbf84a00456d8bb3678a60873066611.svg";
export { ForwardRef as ReactComponent };